import { render, staticRenderFns } from "./AddContactModal.vue?vue&type=template&id=e74872a2&"
import script from "./AddContactModal.vue?vue&type=script&lang=js&"
export * from "./AddContactModal.vue?vue&type=script&lang=js&"
import style0 from "./AddContactModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports